import { useDisclosure } from '@chakra-ui/hooks';
import { Button, Flex, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { FC } from 'react';

import { BlockUser } from '@/components/ui/shared/chat/ChatPopup/components/BlockUser';
import { DeleteChat } from '@/components/ui/shared/chat/ChatPopup/components/DeleteChat';
import { ReportUser } from '@/components/ui/shared/chat/ChatPopup/components/ReportUser';
import { ChatProfile } from '@/components/ui/shared/chat/ChatPopup/components/types';
import { EventChatChannel } from '@/resources/EventChatChannel';

interface IChatChannelOptions {
  profile: ChatProfile;
  channel?: EventChatChannel;
  setProfileSelected: (profile: ChatProfile | null) => void;
}

export const ChatChannelOptions: FC<IChatChannelOptions> = ({ profile, channel, setProfileSelected }) => {
  const { isOpen, onClose, onToggle } = useDisclosure();
  const blockUserState = useDisclosure();
  const deleteChatState = useDisclosure();
  const reportUserState = useDisclosure();

  if (blockUserState.isOpen) {
    return <BlockUser profile={profile} onClose={blockUserState.onClose} />;
  }

  if (deleteChatState.isOpen) {
    return (
      <DeleteChat
        onDelete={() => setProfileSelected(null)}
        chat_channel_id={channel.id}
        onClose={deleteChatState.onClose}
        profile={profile}
      />
    );
  }

  if (reportUserState.isOpen) {
    return <ReportUser profile={profile} onClose={reportUserState.onClose} />;
  }

  return (
    <Popover isOpen={isOpen} onClose={onClose} returnFocusOnClose={true} lazyBehavior="unmount" placement="bottom-end">
      <PopoverTrigger>
        <Button
          onClick={onToggle}
          color="black"
          variant="unstyled"
          _groupHover={{ color: 'black' }}
          size="sm"
          ml="auto"
        >
          ···
        </Button>
      </PopoverTrigger>
      <PopoverContent borderRadius={0} w="100%">
        <Flex w="136px" flexDirection="column" gap={1} fontSize="sm" justifyContent="flex-end" py={1} color="gray.600">
          <Button
            px={4}
            borderRadius={0}
            _hover={{ backgroundColor: 'gray.100', color: 'red.600' }}
            h={7}
            onClick={() => blockUserState.onOpen()}
            textAlign="left"
            fontWeight="normal"
            variant="unstyled"
            size="sm"
            fontSize="sm"
          >
            Block user
          </Button>
          {channel && (
            <Button
              px={4}
              borderRadius={0}
              _hover={{ backgroundColor: 'gray.100', color: 'red.600' }}
              isDisabled={!channel}
              h={7}
              onClick={() => deleteChatState.onOpen()}
              fontWeight="normal"
              textAlign="left"
              variant="unstyled"
              size="sm"
              fontSize="sm"
            >
              Delete chat
            </Button>
          )}
          <Button
            px={4}
            borderRadius={0}
            _hover={{ backgroundColor: 'gray.100', color: 'red.600' }}
            h={7}
            onClick={() => reportUserState.onOpen()}
            fontWeight="normal"
            textAlign="left"
            variant="unstyled"
            size="sm"
            fontSize="sm"
          >
            Report user
          </Button>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
